<div class="padding">
  @if (dataLoading()) {
    <app-loading-animation></app-loading-animation>
  }

  @if (dataAvailable()) {
    <app-table-template
      tableTitle="Documents"
      [showTitle]="false"
      [showSearch]="true"
      [showPagination]="true"
      [showToggle]="true"
      [hasCardView]="true"
      [columns]="columns()"
      [currentPage]="currentPage()"
      [sortedOn]="sortField()"
      [sortDescending]="sortOrder() === -1"
      [tableMinWidthInRem]="68"
      (sortChanged)="sort($event)"
      (searchChanged)="search($event)"
      (pageChanged)="page($event)"
      (cellClicked)="cellClicked($event)">
      <app-entity-document-card [currentPage]="currentPage()" (buttonClicked)="downloadDocument($event)"></app-entity-document-card>
    </app-table-template>
  }

  @if (dataEmpty()) {
    <div class="empty">No documents available</div>
  }
</div>
